import { useKey } from '@core/logic';
import { editModeState } from '@projects/edit-modes/state';
import { EditMode } from '@projects/edit-modes/types';
import { PointColors } from '@trenches/colors';
import { getCachedMaterial, getRenderOrder } from '@viewer3D/helper';
import { sphereGeometry } from '@viewer3D/helper/geometry-cache';
import { Object3dNames } from '@viewer3D/types';
import { type Ref } from 'react';
import type { BufferGeometry, Mesh, MeshBasicMaterial, Vector3 } from 'three';
import { useSnapshot } from 'valtio';

export type MouseSphereMesh = Mesh<BufferGeometry, MeshBasicMaterial>;

interface MouseSphereProps {
  position?: Vector3;
  ref?: Ref<MouseSphereMesh>;
}

export const MouseSphereBase = ({ position, ref }: MouseSphereProps) => {
  const { mode: editMode } = useSnapshot(editModeState);
  const addPressed = useKey('a');

  return (
    <mesh
      ref={ref}
      name={Object3dNames.MouseSphere}
      geometry={sphereGeometry}
      material={getCachedMaterial(PointColors.Endpoint, 0.5, { depthTest: false })}
      visible={addPressed && editMode === EditMode.Trench}
      position={position}
      scale={[0.03, 0.03, 0.03]}
      renderOrder={getRenderOrder(Object3dNames.MouseSphere)}
    />
  );
};

export const MouseSphere = MouseSphereBase;
